import { render, staticRenderFns } from "./updateempowertype.vue?vue&type=template&id=10961490&scoped=true&"
import script from "./updateempowertype.vue?vue&type=script&lang=js&"
export * from "./updateempowertype.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./updateempowertype.vue?vue&type=style&index=1&id=10961490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10961490",
  null
  
)

export default component.exports